import DialerModal from '../DialerModal';
import SettingsModal from '../SettingsModal';
import LogsModal from '../LogsModal';
import AgentsListModal from '../AgentsListModal';
import DTMFModal from '../DTMFModal';
import EmailPreviewModal from '../EmailPreviewModal';
import { ModalName, type ModalNameType } from '../../routes';

type ModalComponent = typeof DialerModal | typeof SettingsModal | typeof LogsModal | typeof AgentsListModal | typeof DTMFModal | typeof EmailPreviewModal;

type ModalRegistryEntry = {
  component: ModalComponent;
  getProps: (params: Record<string, string>) => Record<string, unknown>;
};

export const modalRegistry: Record<ModalNameType, ModalRegistryEntry> = {
  [ModalName.Dialer]: {
    component: DialerModal,
    getProps: ({ to }) => ({ to }),
  },
  [ModalName.Settings]: {
    component: SettingsModal,
    getProps: () => ({}),
  },
  [ModalName.Logs]: {
    component: LogsModal,
    getProps: () => ({}),
  },
  [ModalName.AgentsList]: {
    component: AgentsListModal,
    getProps: ({ excludeIdentity }) => ({ excludeIdentity }),
  },
  [ModalName.DTMF]: {
    component: DTMFModal,
    getProps: () => ({}),
  },
  [ModalName.EmailPreview]: {
    component: EmailPreviewModal,
    getProps: ({ emlUrl, subject }) => ({ emlUrl, subject }),
  },
};
